export default __webpack_public_path__ + "static/media/bukalapak.52c8ab44.svg";